import React from "react";
import { Breadcrumbs } from "@material-tailwind/react";
import { MdOutlineAddPhotoAlternate } from "react-icons/md";
import { MdOutlineHomeWork } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { useState, useEffect } from "react";
import Loading from "../../../COMPONENTS/Loading/Loading";
import { GoArrowLeft } from "react-icons/go";
import SidebarTop from "../../SidebarTop";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Tourisme from "../../../../API/tourisme/lieu/index";
import { GiMoneyStack } from "react-icons/gi";
import { IoMdPin, IoIosMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { CiCalendarDate } from "react-icons/ci";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import { loadStripe } from '@stripe/stripe-js';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import { Button,Form } from "react-bootstrap";
import Select from 'react-select';
import { useTranslation } from "react-i18next";
import Create from "../../../../Payment/Create";


function EditCulture() {
  localStorage.setItem(
    "url",
    JSON.stringify(
      "/Dashboard/Publications/Culture_Decouverte/Voir_les_decouvertes"
    )
  );

  const [data, setData] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("data");
    const initialValue = saved !== null ? JSON.parse(saved) : null;
    return initialValue;
  });

  const navigate = useNavigate();

  const [records, setRecords] = useState([]);
  const [tmprecords, setTmpecords] = useState([]);
  const [address, setAddress] = useState([]);

  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({});

  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [pricePub, setPricePub] = useState(null);
  const [priceD, setPriceD] = useState(null);
  const [errors, setErrors] = useState({});
  const [showInput,setShowInput] = useState(false)
  const [showPopup, setShowPopup] = useState(false);  
  const [pictures,setPictures] = useState([]);
  const [dayr,setDayr] = useState(null)
  const [open,setOpen] = useState(false)
  const [options, setOptions] = useState(null);
  const [curr,setCurr] = useState();
  
  
  
  let fd = new FormData();

   //Récuppérer le prix de publication
       const getPricePub = async () => {
         try {
           const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/pub/culture`);
           //console.log(res.data.data.Prices);
           setPricePub(res.data.data.Prices);
          localStorage.setItem('pricePub', res.data.data.Prices);
         } catch (err) {
           console.log(err);
         }
       };
  
       const getPriceDollar = async () => {
          try {
            const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/dollar`);
            //console.log(res.data.data.value_to_xof);
            setPriceD(res.data.data.value_to_xof);
          } catch (err) {
            console.log(err);
          }
        };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const location = useLocation();
  const id = location.state;

 const handleCountryChange = (selectedOption) => {
      // selectedOption contient directement l'objet { label, value }
      const { value } = selectedOption;
      //setChanged(true);
      setFormData({ ...formData, country: value});
      // Mettre à jour address.code
      setAddress(prevState => ({
        ...prevState,
        code: value
      }));
    
      // Requête pour récupérer les provinces
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${value}`)
        .then((response) => {
          //console.log(response.data.data);
          setProvinces(response.data.data);
        })
        .catch((err) => console.log(err));
    };
    
  
    const handleProvinceChange = (selectedOption) => {
      const { value } =selectedOption;
      //setChanged(true);
      setFormData({ ...formData, province: value });
      setAddress(prevState=>({
        ...prevState,
        code_province:value
      }))
  
      //city
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${value}`)
        .then((response) => {
          setCities(response.data.data);
        })
        //.then(response => console.log(response.data.data))
        .catch((err) => console.log(err));
    };
  
    const handleCityChange = (selectedCity)=>{
      setFormData({ ...formData, ville: selectedCity.value });
      setAddress(prevCity=>({
        ...prevCity,
        code_city:selectedCity.value
      }))
  }
 

  useEffect(() => {
    if (!data) {
      navigate("/Connexion");
    }

     axios
        .get(`${process.env.REACT_APP_BASE_URL}/api/get/info/website`)
        .then((res) => {
        if (res.data.status === 200 ) {
            setCurr(res.data.currency);
            localStorage.setItem('id_currency', res.data.currency.id_currency);
        } else {
            console.warn("Réponse inattendue de l'API :", res.data);
        }
        })
        .catch((err) => {
        console.error("Erreur lors de l'appel à l'API :", err);
        });

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/culture/show/${id}`)
      .then((response) => {
        setRecords(response.data.data);
        setTmpecords(response.data.data);
        setPictures(response.data.pictures);
        //console.log(response);
      })
      //.then(response => console.log(response))
      .catch((err) => console.log(err));

    //country
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/country/list`)
      .then((response) => {
        setCountries(response.data.data);
      })
      //.then(response => console.log(response.data.data))
      .catch((err) => console.log(err));

    //adresse
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/annonce/info/${id}`)
      .then((response) => {
        setAddress(response.data.data);
      })
      .catch((err) => console.log(err));

    const timer = setTimeout(() => {
      // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
      setLoading(false);
    }, 2000); // 5000 millisecondes = 5 secondes

    getPriceDollar();
    getPricePub();
    // Nettoyer le timer si le composant est démonté avant la fin du délai
    return () => clearTimeout(timer);
  }, []);

   useEffect(()=>{
          axios
          .get(`${process.env.REACT_APP_BASE_URL}/api/province/list/${address.code}`)
          .then((response) => {
            //console.log(response.data.data);
            setProvinces(response.data.data);
          })
          .catch((err) => console.log(err));
      
           //city
           axios
           .get(`${process.env.REACT_APP_BASE_URL}/api/city/list/${address.code_province}`)
           .then((response) => {
             setCities(response.data.data);
           })
           //.then(response => console.log(response.data.data))
           .catch((err) => console.log(err));
      
        },[address.code,address.code_province])

  const ValidatedEditCulturForm = ()=>{
    fd.append("id", id);
    fd.append("nom", formData.nom ?? records.title_announce);
    fd.append("adresse", formData.lieu ?? records.contact_address);
    fd.append("desc", formData.msg ?? records.description_announce);
    fd.append("prix", formData.prix ?? records.price_announce);
    fd.append("date_debut", formData.date_debut ?? records.date_debut);
    fd.append("date_fin", formattedDate ?? records.date_fin);

    fd.append("mail", formData.mail ?? records.contact_email);
    fd.append("tel", formData.phone ?? records.contact_phone);
    fd.append("pays", formData.country ?? records.contact_country);
    fd.append("ville", formData.ville ?? records.contact_city);
    fd.append("province", formData.province ?? records.contact_province);
    fd.append("update",'edit');


    for (let i = 0; i < document.getElementById("photo")?.files.length; i++) {
      fd.append("photo[]", document.getElementById("photo")?.files[i]);
    }

    Tourisme.verifyForm(fd)
            .then((res)=>{
                if(res.data.status === 422)
                {
                  setErrors(res.data.errors)
                  setShowPopup(false);
                  return;
                }
                else{
                  if(formattedDate === null || totalPaid === 0 )
                  {
                    SubmitEditCulturForm();
                    return;
                  }else{
                   setShowPopup(true)
                  }
              
            }
            }).catch((error)=>{
              console.log("Erreur lors de l'appel a l'API ",error)
            })
  }

  const SubmitEditCulturForm = (provider,paymentId,currencyId)=>{
      
    fd.append("id", id);
    fd.append("nom", formData.nom ?? records.title_announce);
    fd.append("adresse", formData.lieu ?? records.contact_address);
    fd.append("desc", formData.msg ?? records.description_announce);
    fd.append("prix", formData.prix ?? records.price_announce);
    fd.append("date_debut", formData.date_debut ?? records.date_debut);
    fd.append("date_fin", formattedDate ?? records.date_fin);

    fd.append("mail", formData.mail ?? records.contact_email);
    fd.append("tel", formData.phone ?? records.contact_phone);
    fd.append("pays", formData.country ?? records.contact_country);
    fd.append("ville", formData.ville ?? records.contact_city);
    fd.append("province", formData.province ?? records.contact_province);

    for (let i = 0; i < document.getElementById("photo")?.files.length; i++) {
      fd.append("photo[]", document.getElementById("photo")?.files[i]);
    }
    Tourisme.submitEdit(fd)
      .then((res) => {
        if (res.data.status === 201) {
            if(provider !== null && paymentId !== null && currencyId !== null){
                    const formD = {
                            userId:data.azId,
                            montant:totalPaid,
                            provider: provider,
                            payement_id:paymentId ,
                            currency:currencyId,
                            annonce_number: id,
                            description:"Transaction de modification d'une culture"
                        }
                    axios.post(`${process.env.REACT_APP_BASE_URL}/api/store/rechargement-paiememnt`,formD)
                        .then((res)=>{
                        if(res.data.status === 200){
                        //toast.success(res.data.message);
                        //console.log("enregistrement reussie")
                        }
                        }).catch((err)=>{
                        console.log("Erreur lors de l'appel a l'API ",err)
                        })
            }
          toast.success(res.data.message);
          navigate(
            "/Dashboard/Publications/Culture_Decouverte/Voir_les_decouvertes"
          );
        } else {
          toast.error(res.data.message);
        }
       
      })
      .catch((err) => {
        toast.error("Erreur merci de reessayer !");
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    ValidatedEditCulturForm();
  };

  
    const [formattedDate, setFormattedDate] = useState(null);
    const [totalPaid, setTotalPaid] = useState(null);
    
    let daysToAdd= null;
    const handleDaysChange = (event) => {
      daysToAdd = parseInt(event.target.value, 10); // Assurez-vous que la valeur est bien un nombre
      if (!isNaN(daysToAdd)) {

        const currentDate = new Date();
        const formattedCurrentDate = currentDate.toISOString().split('T')[0];
        let updatedEndDate = null;
        let DateBeforEnd = null;
        if(tmprecords.date_fin < formattedCurrentDate)
        {
            updatedEndDate = new Date(formattedCurrentDate);
        }else{
            updatedEndDate = new Date(tmprecords.date_fin);
            DateBeforEnd = new Date(tmprecords.date_fin).getDate() - new Date(formattedCurrentDate).getDate() 
        }
      
        setDayr(DateBeforEnd + daysToAdd)

        // Créez une copie de endDate pour éviter de modifier l'original à chaque changement
        updatedEndDate.setDate(updatedEndDate.getDate() + daysToAdd);

        const newFormattedDate = `${updatedEndDate.getFullYear()}-${(updatedEndDate.getMonth() + 1).toString().padStart(2, '0')}-${updatedEndDate.getDate().toString().padStart(2, '0')}`;
        setFormattedDate(newFormattedDate);  // Mise à jour de formattedDate
      }
    };

    
    useEffect(() => {
      if (formattedDate !== null) {
        
        const currentDate = new Date();
        const formattedCurrentDate = currentDate.toISOString().split('T')[0];
        let dateDiffInDays = null;
        if(tmprecords.date_fin < formattedCurrentDate)
        {
             dateDiffInDays = (new Date(formattedDate) - new Date(formattedCurrentDate)) / (1000 * 60 * 60 * 24);
    
        }else{
             dateDiffInDays = (new Date(formattedDate) - new Date(tmprecords.date_fin)) / (1000 * 60 * 60 * 24);
        }
        setTotalPaid(parseFloat(pricePub) * Math.ceil(dateDiffInDays));  // Mise à jour de totalPaid
      }
    }, [formattedDate]);

    useEffect(() => {
                if (curr) {
            
                setOptions({
                    id_currency: curr.id_currency,
                    success_url: window.location.origin ,
                    cancel_url: window.location.href,
                    amount:totalPaid,
                    customer: {
                    id: data.azId,
                    first_name: data.userLastname ?? '',
                    last_name: data.userName ?? '',
                    email: data.userMail,
                    phone: data.userTel,
                    code_country: 'BJ'
                    },
                    seller_number: 1
                });
                }
      }, [curr,totalPaid]);

    const checkboxClick= ()=>setShowInput(!showInput)


  const today = new Date().toISOString().split("T")[0];

  const handleDeleteImage = async (id,idImage)=>{
     await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/culture/delete/${id}/${idImage}`)
           .then((res)=>{
              if(res.data.status === 200)
              {
                  setPictures(res.data.pictures)
                  toast.success("Image supprimer avec success")
                  return;
              }
              if(res.data.status === 422)
              {
                  toast.success(res.data.message)
                  return;
              }
           }).catch((err)=>{
              console.log("Erreur lors de l'appel a l'API ",err)
           })
  }

  const {t} = useTranslation()
  const lang = localStorage.getItem("langague");

  return (
    <div className="flex flex-row bg-[#eeee]">
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          {/* sidebar left */}

          <div className="w-screen  barre_scroll h-screen">
            {/* navbar top orange */}
            <SidebarTop />
            {/* navbar top gris*/}
            <div className="bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]">
              <Breadcrumbs>
                <Link to="" className="opacity-60 md:text-base s:text-xs">
                  {t("Mes publications")}
                </Link>
                <Link
                  to="/Dashboard/Publications/Culture_Decouverte/Voir_les_decouvertes"
                  className="opacity-60 md:text-base s:text-xs"
                >
                  {t("Culture & Decouverte")}
                </Link>
                <Link to="" className="md:text-base s:text-xs">
                  {t("Modifier")}
                </Link>
              </Breadcrumbs>
            </div>

            <div>
              <ToastContainer />
            </div>

            <Link to="/Dashboard/Publications/Culture_Decouverte/Voir_les_decouvertes">
              <div className="flex flex-row items-center space-x-2 relative top-8 s:left-5 sm:left-12 w-[280px]">
                <GoArrowLeft className="text-[#fe7f2d]  text-lg" />
                <p>{t("Retour à la page précdente")}</p>
              </div>
            </Link>
            {/* container formulaire */}
            <div className="flex justify-center py-20 ">
              <form
                onSubmit={handleSubmit}
                className="flex flex-col space-y-3   "
              >
                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-6 ">
                  {/* Ajout des images */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineAddPhotoAlternate className="text-xl text-[#fe7f2d]" />
                      <label> {t("Ajouter des images du site")}</label>
                      <div onClick={()=>setOpen(true)}  className="text-blue-500 cursor-pointer ">
                        {pictures.length + t(" files")}
                      </div>
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      id="photo"
                      multiple
                      name="photo"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 "
                    />
                  </div>
                  {/* Nom du site toristique */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineHomeWork className="text-xl text-[#fe7f2d]" />
                      <label>{t("Nom")}</label>
                    </div>
                    <input
                      type="text"
                      defaultValue={tmprecords.title_announce}
                      onChange={handleInputChange}
                      name="nom"
                      placeholder="Ex : Les cascade de Man"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.nom && <p className="text-red-500">{errors.nom}</p>}
                  </div>

                  {/* Tarif */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <GiMoneyStack className="text-xl text-[#fe7f2d]" />
                      <label>{t("Tarif")} </label>
                    </div>
                    <input
                      defaultValue={tmprecords.price_announce}
                      onChange={handleInputChange}
                      type="number"
                      name="prix"
                      required
                      placeholder="Ex : 10000 "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.prix && <p className="text-red-500">{errors.prix}</p>}
                  </div>

                  {/* Description */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <AiOutlineEdit className="text-xl text-[#fe7f2d]" />
                      <label>{t("Description")}</label>
                    </div>
                    <textarea
                      defaultValue={tmprecords.description_announce}
                      onChange={handleInputChange}
                      name="msg"
                      required
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] rounded p-2 h-[200px]"
                    ></textarea>
                  </div>
                </div>

                <div className="bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 ">
                  {/* Tel */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <FaPhoneAlt className=" text-[#fe7f2d]" />
                      <label>{t("Telephone")}</label>
                    </div>
                    <input
                      type="tel"
                      defaultValue={tmprecords.contact_phone}
                      name="phone"
                      onChange={handleInputChange}
                      required
                      placeholder="Ex : +225 xxx xxx xxxx "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.tel && <p className="text-red-500">{errors.tel}</p>}
                  </div>
                  {/* Mail */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoIosMail className=" text-[#fe7f2d]" />
                      <label>{t("Adresse e-mail")}</label>
                    </div>
                    <input
                      type="email"
                      defaultValue={tmprecords.contact_email}
                      name="mail"
                      onChange={handleInputChange}
                      placeholder="Ex : info@monbonsejour.com "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.mail && <p className="text-red-500">{errors.mail}</p>}
                  </div>
                  {/* Country */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Pays")}</label>
                    </div>
                    <Form.Group>
                          <Select
                              onChange={handleCountryChange}
                              name="country"  
                              value={address.code ? { 
                                     label: lang === 'fr' ? countries.find(pay => pay?.code === address.code)?.fr_Name
                                      : countries.find(pay => pay?.code === address.code)?.Name, 
                                      value: address.code } : null} // Inclut la propriété value
                              options={countries.map(pay => ({
                                  label: lang === 'fr' ? pay?.fr_Name : pay?.Name,
                                  value: pay?.code
                              }))}
                              className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                          />
                    </Form.Group>
                    {/* <select
                      onChange={handleCountryChange}
                      name="country"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value={address.code}>{address.fr_Name}</option>
                      {countries.map((option, index) => (
                        <option key={index} value={option.code}>
                          {option.fr_Name}
                        </option>
                      ))}
                    </select> */}
                    {errors.pays && <p className="text-red-500">{errors.pays}</p>}
                  </div>
                  {/* Province */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Province")}</label>
                    </div>
                    <Form.Group>
                      <Select
                          onChange={handleProvinceChange}
                          name="province"  
                          value={address.code_province ? {
                                 label: lang === 'fr' ? provinces.find(prov => prov?.code_province === address.code_province)?.fr_Name
                                 :provinces.find(prov => prov?.code_province === address.code_province)?.Name, 
                                 value:address.code_province} : null} // Inclut la propriété value
                          options={provinces.map(prov => ({
                              label: lang === 'fr' ? prov?.fr_Name : prov?.Name ,
                              value: prov?.code_province
                          }))}
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                      />
                    </Form.Group>

                    {/* <select
                      onChange={handleProvinceChange}
                      name="province"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value={address.code_province}>
                        {address.pname}
                      </option>
                      {provinces.map((option, index) => (
                        <option key={index} value={option.code_province}>
                          {option.fr_Name}
                        </option>
                      ))}
                    </select> */}
                    {errors.province && <p className="text-red-500">{errors.province}</p>}
                  </div>
                  {/* Ville */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Ville")}</label>
                    </div>

                     <Form.Group>
                              <Select
                                  onChange={handleCityChange}
                                  name="ville"  
                                  value={address.code_city ? { 
                                         label: lang === 'fr' ? cities.find(city => city?.code_city === address.code_city)?.fr_Name
                                          : cities.find(city => city?.code_city === address.code_city)?.Name,
                                           value: address.code_city} : null} // Inclut la propriété value
                                  options={cities.map(city => ({
                                      label: lang === 'fr' ? city?.fr_Name : city?.Name,
                                      value: city?.code_city
                                  }))}
                                  className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                              />
                      </Form.Group>
                    {/* <select
                      onChange={handleInputChange}
                      name="ville"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value={address.code_city}>{address.cname}</option>
                      {cities.map((option, index) => (
                        <option key={index} value={option.code_city}>
                          {option.fr_Name}
                        </option>
                      ))}
                    </select> */}
                    {errors.ville && <p className="text-red-500">{errors.ville}</p>}
                  </div>
                  {/* Lieu */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Lieu")}</label>
                    </div>
                    <input
                      type="text"
                      defaultValue={tmprecords.contact_address}
                      name="lieu"
                      onChange={handleInputChange}
                      placeholder="Ex : Cocody, Abidjan, Côte d'ivoire "
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.adresse && <p className="text-red-500">{errors.adresse}</p>}
                  </div>
                </div>

                <div className="bg-white s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px] rounded-md border-b-8  shadow flex flex-col space-y-3 ">
                  {/* date debut */}
                  {/* <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <CiCalendarDate className=" text-[#fe7f2d]" />
                      <label>Date de debut affichage</label>
                    </div>
                    <input
                      defaultValue={tmprecords.date_debut}
                      name="date_debut"
                      onChange={handleInputChange}
                      type="date"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      required
                      min={today}
                    />
                  </div> */}

                  {/* date fin */}
                  {/* <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <CiCalendarDate className=" text-[#fe7f2d]" />
                      <label>Date de fin affichage</label>
                    </div>
                    <input
                      defaultValue={tmprecords.date_fin}
                      name="date_fin"
                      onChange={handleInputChange}
                      type="date"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      required
                      min={today}
                    />
                  </div> */}
                   <div className="flex flex-row items-center space-x-2">
                      <input
                        onClick={checkboxClick}
                        type="checkbox"                       
                      />
                      <label>{t("Ajouter des jours")}?</label>
                   </div>
                   {
                    showInput &&(
                        <input
                        type="text"
                        name="days"
                        onChange={handleDaysChange}
                        placeholder={t("Entrer le nombre de jours que vous voulez?")}
                        className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                      />
                    )
                   }
                   
                   <div className="bg-blue-900 rounded-lg shadow-lg p-6 text-white max-w-md mx-auto my-4">
                    <h3 className="text-xl font-semibold mb-4 border-b border-blue-700 pb-2">{t("Affichage")}:</h3>
                    <div className="space-y-2">
                      <div className="flex items-center">
                        <span className="font-medium w-32">{t("Date de début")}:</span>
                        <span className="bg-blue-800 px-3 py-1 rounded">
                          {new Date(tmprecords.date_debut).toLocaleDateString('fr-FR')}
                        </span>
                      </div>
                      <div className="flex items-center">
                      <span className="font-medium w-32">{t("Date de fin")}:</span>
                        <span className="bg-blue-800 px-3 py-1 rounded">
                          {new Date(tmprecords.date_fin).toLocaleDateString(
                            "fr-FR"
                          )}
                        </span>
                      </div>
                      {
                        !isNaN(daysToAdd) && new Date(formattedDate).toLocaleDateString("fr-FR") !== "01/01/1970"  && (
                          <>
                               <div className="mb-4 border-b border-blue-700 pb-2  flex items-center">
                                <span className="font-medium w-32">{t("Nouvelle")} <br/> {t("date de fin")}:</span>
                                  <span className="bg-blue-800 px-3 py-1 rounded">
                                    {new Date(formattedDate).toLocaleDateString(
                                      "fr-FR"
                                    )}
                                  </span>
                              </div>
                              <div className="flex items-center">
                              <span className="font-medium w-32">{t("Nombre de")}  <br/> {t("jour(s) restant")}:</span>
                                <span className="bg-blue-800 px-3 py-1 rounded">
                                  {dayr}
                                </span>
                              </div>
                          </>
                        )
                      }

                    </div>
                  </div>
                </div>
                <button className="bg-[#FCCA46] w-[150px] h-10 rounded text-white">
                  {t("Modifier")}

                </button>
              </form>

              {
                showPopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                        {/* Bouton de fermeture à l'intérieur du modal */}
                        <button
                        onClick={() => setOpen(false)}
                        className="absolute top-3 right-3 text-red-500 text-2xl"
                    >
                        &times;
                    </button>
                        <Create item="Rechargement de la carte AZ"  options={options} onSuccess={SubmitEditCulturForm} ></Create>
                    </div>
                </div>
                )
              }

              {/** Modal d'image */}
                {
                  open && (
                    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                      <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                        {/* Bouton de fermeture à l'intérieur du modal */}
                        <button
                          onClick={() => setOpen(false)}
                          className="absolute top-3 right-3 text-red-500 text-2xl"
                        >
                          &times;
                        </button>
                        
                        <h2 className="text-center text-xl font-semibold mb-4">{t("Les images de")} {tmprecords.title_announce}</h2>
                        
                        <div className="grid grid-cols-3 gap-4">
                          {pictures.map((picture, index) => (
                            <div key={index} className="relative">
                              <img
                                src={`data:image/png;base64,${picture.picture}`} 
                                alt="image preview"
                                className="w-full h-auto rounded-lg"
                              />
                              <button
                                 onClick={()=>handleDeleteImage(id,picture.id)} // Logic to remove image (if implemented)
                                className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1"
                              >
                                &times;
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )
                }


            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default EditCulture;
